import React from 'react';

import titleBoxStyles from './title-box.module.scss';

const TitleBox: React.FC = ({ children }) => (
  <div className={titleBoxStyles.titleBox}>{children}</div>
);

export default TitleBox;
